import React from "react";
import {isFinite} from "lodash";
import moment from "moment";

function withFiniteValues(WrappedComponent) {
    return class extends React.Component {
        render() {
            return <WrappedComponent
                {...this.props}
                start={isFinite(this.props.start) ? this.props.start : +moment.utc().startOf("day")}
                end={isFinite(this.props.end) ? this.props.end : +moment.utc().startOf("day")}
            />
        }
    }
}

export default withFiniteValues;
